import React from 'react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { TrustIcons } from './TrustIcons';
import { checkoutUrl, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="inversion" className="w-full bg-white py-16 md:py-24" data-id="element-99" data-mp="2jknqblhfrnqr">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-100" data-mp="1vts18w4d76n7">
        {showUrgency && <CountdownPanel headline="Atención: esta oferta de lanzamiento vence en 48 horas" subtext="Después, el precio sube a $24.990. Mañana es tarde." data-id="element-101" data-mp="1rsq0gausumj4" />}

        <h2 className="mt-16 text-center font-display text-[2rem] font-extrabold leading-tight tracking-tight text-night md:text-5xl" data-id="element-102" data-mp="20teev6o3uowj">
          Tu inversión hoy
        </h2>

        <div className="mx-auto mt-10 max-w-narrow rounded-3xl bg-canvas p-7 text-center shadow-lift ring-1 ring-gray-200 md:p-12" data-id="element-103" data-mp="3h97mm09av4td">
          <p className="text-lg text-gray-500" data-id="element-104" data-mp="3vzynqjgdld45">
            Valor sin descuento: <span className="line-through" data-id="element-105" data-mp="3w1t5xq09ir4j">{offer.listPrice} ARS</span>
          </p>

          <p className="mt-4 font-display text-6xl font-extrabold leading-none tracking-tight text-night md:text-7xl" data-id="element-106" data-mp="4v8n2tkd2pil">
            {offer.price}
            <span className="ml-2 align-middle text-xl font-semibold text-gray-500" data-id="element-107" data-mp="erv2h2tx4od8">
              {offer.currency}
            </span>
          </p>

          <p className="mt-5 inline-block rounded-lg bg-amber-400 px-4 py-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-night" data-id="element-108" data-mp="3das855avp1mk">
            {offer.subtitle}
          </p>

          <p className="mx-auto mt-7 max-w-xl text-lg leading-relaxed text-gray-600" data-id="element-109" data-mp="3n5u1kdc6spuy">
            {offer.detail}
          </p>

          <div className="mt-9" data-id="element-110" data-mp="2uihbht6thzww">
            <CtaButton size="xl" href={checkoutUrl} className="w-full" data-id="element-111" data-mp="2uj96b1slbtm4">
              {offer.cta}
            </CtaButton>
          </div>
        </div>

        <TrustIcons className="mt-10" data-id="element-112" data-mp="2zf7sciqg4zjd" />
      </div>
    </section>;
}